import React, { useState, useEffect ,forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {toast } from 'react-hot-toast';
import { Updateclients, Editclients, GetState, LicenceCheck } from '../../store/slices/client';
import Select from 'react-select';

const Profile = (props, ref) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [getState, setGetState] = useState([]);

  const [licenceError, setLicenceError] = useState('');
  const [selectedState, setSelectedstate] = useState(null);
  const user = JSON.parse(localStorage.getItem('user'));

  const UserID = user?.data?.profile_id;

  const [formData, setFormData] = useState({
    id: UserID ,
    name: '',
    phoneno: '',
    invoice_email: '',
    address: '',
    company_name: '',
    gst: '',
    state: '',
    city: '',
    company_incorporation_date: '',
    cin:'',
    pin_code: ''
  });
  const [initialFormData, setInitialFormData] = useState(null);


  const fetchClientDetails = async () => {
    if (!UserID) return;

    try {
      setIsLoading(true);
      const data = await dispatch(Editclients({ id: UserID })).unwrap();
      setIsLoading(false);

      const item = data?.data;

      if (item?.state) {
        const ndata = await fetchStates();
        handleStateChange(item?.state, ndata, true);
      }

      setFormData((prevFormData) => ({
        ...prevFormData,
        id: UserID || '',
        name: item?.name || '',
        address: item?.address || '',
        invoice_email: item?.invoice_email || '',
        phoneno: item?.phoneno || '',
        gst: item?.gst || '',
        company_name: item?.company_name || '',
        state: item?.state || '',
        city: item?.city || '',
        profile_img: item?.profile_img || '',
        company_incorporation_date: item?.company_incorporation_date || '',
        cin: item?.cin || '',
        pin_code: item?.pin_code || '',
      }));
      setInitialFormData(item);
    } catch (error) {
      setIsLoading(false);
      console.log(error?.message || 'Something went wrong while fetching client details');
    }
  };

  useEffect(() => {
    fetchClientDetails()

  }, [dispatch, UserID]);

  // Fetch parties

  useEffect(() => {
    fetchStates();
  }, [dispatch, UserID]);

  const [errors, setErrors] = useState({});

  const fetchStates = async () => {
    try {
      const data = await dispatch(GetState()).unwrap();
      setGetState(data?.data);
      return data?.data;
    } catch (error) {
      console.log('Error fetching parties:', error.message);
    }
  };

  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}Z[0-9A-Z]{1}$/;


  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;

    // Handle licence_key logic
    if (name === 'licence_key') {
      if (!formData.partner_id) {
        setLicenceError('Select Client Ownership');
      } else {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));

        // Dispatch the LicenceCheck action to validate the license key
        dispatch(LicenceCheck({ licence_key: value, partner_id: formData.partner_id }))
          .unwrap()
          .then((response) => {
            if (response.status) {
              setLicenceError('');
            } else {
              setLicenceError(response.message);
            }
          })
          .catch((error) => {
            console.log('Error checking Licence:', error);
          });
      }
      return;
    }

    // GST validation logic
    if (name === 'gst') {
      if (!gstRegex.test(value)) {
        setErrors((prevState) => ({
          ...prevState,
          gst: 'Invalid GST number. Please enter a valid GSTIN.',
        }));
      } else {
        setErrors((prevState) => ({
          ...prevState,
          gst: '',
        }));
      }
    }


    // Handle number validation for opening balance
    if (name === 'opening_balance') {
      if (/^\d*\.?\d{0,2}$/.test(value)) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleStateChange = (selectedOption, ndata, isData) => {
    // console.log('selectedOption, ndata, isData', selectedOption, ndata, isData);

    const FinalselectedOption = isData ? selectedOption : selectedOption?.value;
    // console.log('FinalselectedOption select ', FinalselectedOption);
    if (!FinalselectedOption) {
      console.error('FinalselectedOption is undefined or invalid');
      return;
    }
    const GetState = isData ? ndata : getState;
    const party = GetState?.find((p) => p?.state_name == FinalselectedOption);
    setSelectedstate(party.state_name);
    setFormData((prevFormData) => ({ ...prevFormData, state: party.state_name }));
  };

  const statesOptions = getState.map((state) => ({
    value: state.state_name,
    label: state.state_name,
  }));

  const [files, setFiles] = useState({
    profile_img: null,
  });
  const [validationErrors, setValidationErrors] = useState({
    profile_img: null,
  });

const handleFileChange = (e) => {
  const { name, files: selectedFiles } = e.target;
  const file = selectedFiles[0];
  let error = null;

  if (file) {
    const allowedExtensions = ['.jpg', '.png', '.jpeg'];
    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      error = 'Invalid file type.';
    }
  }

  setFiles((prevFiles) => {
    const updatedFiles = {
      ...prevFiles,
      [name]: file,
    };
    return updatedFiles;
  });

  setValidationErrors((prevErrors) => ({
    ...prevErrors,
    [name]: error,
  }));

  // ✅ Automatically submit when a valid file is selected
  if (file && !error) {
    setTimeout(() => {
      handleSubmit();
    }, 100);
  }
};


  const validate = () => {
    let newErrors = {};

    if (!formData.name) newErrors.name = 'Name is required.';
    if (!formData.company_name) newErrors.company_name = 'Company Name is required.';
    if (!formData.state) newErrors.state = 'State is required.';
    if (!formData.company_incorporation_date) newErrors.company_incorporation_date = 'Company Incorporation Date is required.';
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

const isFormChanged = () => {
  if (!initialFormData) return true;

  const textChanged = Object.keys(formData).some(
    (key) => formData[key] !== initialFormData[key]
  );

  const fileChanged = Object.values(files).some((file) => file !== null);

  return textChanged || fileChanged;
};


  const handleSubmit = () => {
    if (!isFormChanged()) {
      console.log("No changes detected. Skipping submit.");
      return;
    }
    const submitData = new FormData();
    // Append the text data
    for (let key in formData) {
      submitData.append(key, formData[key]);
    }

    // Append the files
    for (let key in files) {
      if (files[key]) {
        // Only append if a file is selected
        submitData.append(key, files[key]);
      }
    }

    if (validate()) {
      // Submit the form data
      setIsLoading(true);
      dispatch(Updateclients(submitData)) // Using FormData directly here
        .unwrap()
        .then((data) => {
          console.log(data?.data);
          fetchClientDetails()
          setIsLoading(false);
          setFormData({
            id: UserID || '',
            name: '',
            address: '',
            phoneno: '',
            gst: '',
            company_name: '',
            state: '',
            city: '',
            profile_img: '',
            company_incorporation_date: '',
            cin: '',
          });
          setFiles({
            profile_img: null,
          });
          toast.success('Setting updated successfully!')
         
        })
        .catch(({ message }) => {
          setIsLoading(false);
          console.log(message);
        });
    }
  };



  useImperativeHandle(ref, () => ({
    callChildFunction: handleSubmit,
  }));

  

// console.log("formData",formData)
  return (
    <>
      <div id="Profile" role="tabpanel" aria-labelledby="Profile-tab">
        <div className="row content-body">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card custom-card" style={{ border: 'none' }}>
                  <div className="card-body">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <label>
                            Company Name <span class="required">*</span>
                          </label>
                          <input name="company_name" type="text" class="form-control" value={formData.company_name} onChange={handleInputChange} />
                          {errors.company_name && <span className="text-danger">{errors.company_name}</span>}
                        </div>
                        <div class="col-md-6">
                          <label>
                            Owner Name <span class="required">*</span>
                          </label>
                          <input name="name" type="text" className="form-control" value={formData.name} onChange={handleInputChange} />
                          {errors.name && <span className="text-danger">{errors.name}</span>}
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <label>
                            Company Incorporation Date <span class="required">*</span>
                          </label>
                          <input name="company_incorporation_date" type="date" class="form-control mt_5" value={formData.company_incorporation_date} onChange={handleInputChange}></input>
                          {errors.company_incorporation_date && <span className="text-danger">{errors.company_incorporation_date}</span>}
                        </div>
                        <div class="col-md-6">
                          <label>Address</label>
                          <textarea name="address" rows="2" cols="20" maxlength="150" id="address" class="form-control mt_5" value={formData.address} onChange={handleInputChange}></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-3">
                          <label>City</label>
                          <input name="city" type="text" class="form-control" required value={formData.city} onChange={handleInputChange} />
                        </div>
                          <div class="col-md-3">
                          <label>Pin Code</label>
                          <input name="pin_code" type="text" class="form-control" required value={formData.pin_code} onChange={handleInputChange} />
                        </div>
                        <div class="col-md-6">
                          <label>
                            State<span class="required">*</span>{' '}
                          </label>
                          <Select
                            options={statesOptions}
                            name="state"
                            placeholder="--Select State--"
                            required
                            onChange={handleStateChange}
                            value={statesOptions?.find((option) => option?.value === selectedState) || null}
                          />
                          {errors.state && <span className="text-danger">{errors.state}</span>}
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <label>Phone No</label>
                          <input name="phoneno" type="number" className="form-control" value={formData.phoneno} onChange={handleInputChange} />
                        </div>
                        <div class="col-md-6">
                          <label>Invoice Email</label>
                          <input name="invoice_email" type="text" class="form-control" value={formData.invoice_email} onChange={handleInputChange} />
                          {/* {errors.email && <span className="text-danger">{errors.email}</span>} */}
                        </div>
                      </div>
                    </div>
                       <div class="form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <label>CIN Number</label>
                          <input name="cin" type="text" className="form-control" value={formData.cin} onChange={handleInputChange} />
                        </div>
                       <div class="col-md-6">
                        <label>GST Number </label>
                        <input name="gst" type="text" class="form-control" value={formData.gst} onChange={handleInputChange} />
                        {errors.gst && <span className="text-danger">{errors.gst}</span>}
                      </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <label>Logo</label>
                          <input name="profile_img" type="file" class="form-control" accept=".jpeg, .png, .jpg, .webp, .svg" onChange={handleFileChange} />{' '}
                        </div>
                       
                      </div>
                    
                      <div className="col-sm-6 ">
                        {formData.profile_img &&
                          (/\.(jpeg|jpg|png|webp|svg)$/i.test(formData.profile_img) ? (
                            <img src={formData.profile_img} alt="profile_img" style={{ width: '100px' }} />
                          ) : (
                            <a href={formData.profile_img} download target="_blank">
                              Download Image
                            </a>
                          ))}
                      </div>
                    </div>
                    {/* <div className="form-group">
                      <div className="row">
                        <div className="col-md-6">
                          <button type="submit" className="btn btn-default" onClick={handleSubmit}>
                            Update
                          </button>
                          &nbsp;
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default forwardRef(Profile);
